
import { Component, Vue} from 'vue-property-decorator';
import NavigationSidebar from "./NavigationSidebar.vue";

import GetStartedStep from "./steps/get-started/GetStartedStep.vue";
import ReplyFamilyLawStep from "./steps/replyFamilyLawMatter/ReplyFamilyLawStep.vue";
import WrittenResponseStep from "./steps/writtenResponse/WrittenResponseStep.vue";
import CounterApplicationStep from "./steps/counterApplication/CounterApplicationStep.vue";
import FamilyLawManualStep from "./steps/familyLawManual/FamilyLawManualStep.vue";
import CommonInformationStep from "./steps/common-information/CommonInformationStep.vue";
import StepProtectionOrder from "./steps/protectionOrder/StepProtectionOrder.vue";
import FamilyLawStep from "./steps/familyLawMatter/FamilyLawStep.vue";
import ParentingPriorityStep from "./steps/priorityParenting/ParentingPriorityStep.vue";
import CaseManagementStep from "./steps/caseMgmt/CaseManagementStep.vue";
import ChildRelocationStep from "./steps/childReloc/ChildRelocationStep.vue";
import EnforcementAgreeStep from "./steps/agreementEnfrc/EnforcementAgreeStep.vue";
import StepConnect from "./steps/connect/StepConnect.vue";
import OtherFormStep from "./steps/otherFamilyForms/OtherFormStep.vue";
import AddressChangeStep from "./steps/addressChange/AddressChangeStep.vue";
import DiscontinuanceStep from "./steps/discontinuance/DiscontinuanceStep.vue";
import IntentionProceedStep from "./steps/intentionProceed/IntentionProceedStep.vue";
import AffidavitStep from "./steps/affidavit/AffidavitStep.vue";
import GuardianshipAffidavitStep from "./steps/guardianshipAffidavit/GuardianshipAffidavitStep.vue";
import AffidavitPersonalServiceStep from "./steps/affidavitPersonalService/AffidavitPersonalServiceStep.vue";
import AffidavitPersonalServicePoStep from "./steps/affidavitPersonalServicePO/AffidavitPersonalServicePOStep.vue";
import CertificateOfServiceStep from "./steps/certificateOfService/CertificateOfServiceStep.vue";
import FinancialStatementStep from "./steps/financialStatement/FinancialStatementStep.vue";
import RequestSchedulingStep from "./steps/requestScheduling/RequestSchedulingStep.vue";
import RemoveLawyerPartyStep from "./steps/noticeRemoveLawyerParty/RemoveLawyerPartyStep.vue";
import LawyerPartyStep from "./steps/noticeLawyerParty/LawyerPartyStep.vue";
import RemoveLawyerChildStep from "./steps/noticeRemoveLawyerChild/RemoveLawyerChildStep.vue";
import LawyerChildStep from "./steps/noticeLawyerChild/LawyerChildStep.vue";
import TrialReadinessStatementStep from "./steps/trialReadinessStatement/TrialReadinessStatementStep.vue";
import StepSubmit from "./steps/submit/StepSubmit.vue";

import * as surveyEnv from "@/components/survey/survey-glossary";

@Component({
    components: {
        NavigationSidebar,
        StepProtectionOrder,
        CommonInformationStep,
        StepConnect,
        StepSubmit,
        FamilyLawStep,
        ParentingPriorityStep,
        CaseManagementStep,
        ChildRelocationStep,
        EnforcementAgreeStep,
        GetStartedStep,
        ReplyFamilyLawStep,
        WrittenResponseStep,
        CounterApplicationStep,
        OtherFormStep,
        AddressChangeStep,
        DiscontinuanceStep,
        IntentionProceedStep,
        RequestSchedulingStep,
        TrialReadinessStatementStep,
        LawyerChildStep,
        RemoveLawyerChildStep,
        LawyerPartyStep,
        RemoveLawyerPartyStep,
        AffidavitStep,
        GuardianshipAffidavitStep,
        AffidavitPersonalServiceStep,
        AffidavitPersonalServicePoStep,
        CertificateOfServiceStep,
        FinancialStatementStep,
        FamilyLawManualStep
    }
})

export default class FlappSurveys extends Vue {
  
    beforeCreate() {    
        surveyEnv.loadGlossary();
    }

    public getCurrentStepIndex() {
        return this.$store.state.Application.currentStep;
    }

    public getStep(stepIndex) {        
        return this.$store.state.Application.steps[stepIndex];
    }

}
